import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {useNavigate, useParams} from "react-router-dom";
import {baseUrl, ipAddress, userLocation, userName} from "../Univ.js";
import "./IoTStyles.css";
function IoTDeviceForm() {
    const navigate = useNavigate();
    const {id} = useParams();
    const [loading, setLoading] = useState(false);
    const [gateways, setGateways] = useState([]);
    const [formData, setFormData] = useState({
        device_id: "",
        device_name: "",
        device_type: "PATIENT_MONITOR",
        manufacturer: "",
        model_number: "",
        serial_number: "",
        firmware_version: "",
        protocol: "HL7",
        ip_address: "",
        port: "",
        mac_address: "",
        ae_title: "",
        gateway: "",
        ward: "",
        room: "",
        bed: "",
        status: "ACTIVE",
        installation_date: "",
        warranty_expiry: "",
        calibration_due: "",
        service_due: ""
    });
    useEffect(() => {
        fetchGateways();
        if (id) {
            fetchDevice();
        }
    }, [id]);
    const fetchGateways = async () => {
        try {
            const response = await axios.get(
                baseUrl + "iot-gateways/"
            );
            setGateways(response.data);
        } catch (error) {
            console.log(error);
        }
    };
    const fetchDevice = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                baseUrl + "iot-devices/" + id + "/"
            );
            setFormData({
                ...formData,
                ...response.data,
                gateway:
                    response.data.gateway || ""
            });
        } catch (error) {
            console.log(error);
            Swal.fire(
                "Error",
                "Unable to load device.",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };
    const inputHandler = (event) => {
        const {
            name,
            value
        } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const submitHandler = async (event) => {
        event.preventDefault();
        if (
            !formData.device_id ||
            !formData.device_name ||
            !formData.device_type ||
            !formData.protocol
        ) {
            Swal.fire(
                "Required",
                "Please fill all mandatory fields.",
                "warning"
            );
            return;
        }
        try {
            setLoading(true);
            const payload = {
                ...formData,
                gateway:
                    formData.gateway === ""
                        ? null
                        : formData.gateway,
                addedby: userName,
                ip_add: ipAddress,
                location: userLocation
            };
            let response;
            if (id) {
                response = await axios.put(
                    baseUrl +
                    "iot-devices/" +
                    id +
                    "/",
                    payload
                );
            } else {
                response = await axios.post(
                    baseUrl +
                    "iot-devices/",
                    payload
                );
            }
            if (
                response.status === 200 ||
                response.status === 201
            ) {
                Swal.fire({
                    title: id
                        ? "Device Updated"
                        : "Device Registered",
                    text: "IoT device saved successfully.",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false
                });
                setTimeout(() => {
                    navigate("/iot-devices/");
                }, 1500);
            }
        } catch (error) {
            console.log(error);
            Swal.fire(
                "Error",
                "Unable to save IoT device.",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };
    return (
        <section className="container mt-4">

            <div className="iot-page-header">

                <div>

                    <h3>

                        {id
                            ? "Edit IoT Device"
                            : "Register IoT Device"}

                    </h3>

                    <p>
                        Configure a hospital IoT device
                    </p>

                </div>

            </div>


            <form onSubmit={submitHandler}>

                <div className="card shadow-sm mb-4">

                    <div className="card-header">

                        <strong>
                            Device Information
                        </strong>

                    </div>


                    <div className="card-body">

                        <div className="row">

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Device ID *
                                </label>

                                <input
                                    type="text"
                                    name="device_id"
                                    className="form-control"
                                    value={
                                        formData.device_id
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                    disabled={!!id}
                                />

                            </div>


                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Device Name *
                                </label>

                                <input
                                    type="text"
                                    name="device_name"
                                    className="form-control"
                                    placeholder="ICU Patient Monitor 01"
                                    value={
                                        formData.device_name
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>

                        </div>


                        <div className="row">

                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    Device Type *
                                </label>

                                <select
                                    name="device_type"
                                    className="form-control"
                                    value={
                                        formData.device_type
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                >

                                    <option value="PATIENT_MONITOR">
                                        Patient Monitor
                                    </option>

                                    <option value="ECG">
                                        ECG
                                    </option>

                                    <option value="SPO2">
                                        SpO2
                                    </option>

                                    <option value="BP">
                                        Blood Pressure
                                    </option>

                                    <option value="GLUCOSE">
                                        Glucose
                                    </option>

                                    <option value="VENTILATOR">
                                        Ventilator
                                    </option>

                                    <option value="INFUSION_PUMP">
                                        Infusion Pump
                                    </option>

                                    <option value="LAB_ANALYZER">
                                        Lab Analyzer
                                    </option>

                                    <option value="SMART_BED">
                                        Smart Bed
                                    </option>

                                    <option value="OTHER">
                                        Other
                                    </option>

                                </select>

                            </div>


                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    Manufacturer
                                </label>

                                <input
                                    type="text"
                                    name="manufacturer"
                                    className="form-control"
                                    value={
                                        formData.manufacturer
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>


                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    Model Number
                                </label>

                                <input
                                    type="text"
                                    name="model_number"
                                    className="form-control"
                                    value={
                                        formData.model_number
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>

                        </div>


                        <div className="row">

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Serial Number
                                </label>

                                <input
                                    type="text"
                                    name="serial_number"
                                    className="form-control"
                                    value={
                                        formData.serial_number
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>


                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Firmware Version
                                </label>

                                <input
                                    type="text"
                                    name="firmware_version"
                                    className="form-control"
                                    value={
                                        formData.firmware_version
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>

                        </div>

                    </div>

                </div>


                <div className="card shadow-sm mb-4">

                    <div className="card-header">

                        <strong>
                            Communication
                        </strong>

                    </div>


                    <div className="card-body">

                        <div className="row">

                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    Protocol *
                                </label>

                                <select
                                    name="protocol"
                                    className="form-control"
                                    value={
                                        formData.protocol
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                >

                                    <option value="HL7">
                                        HL7
                                    </option>

                                    <option value="ASTM">
                                        ASTM
                                    </option>

                                    <option value="MQTT">
                                        MQTT
                                    </option>

                                    <option value="TCP">
                                        TCP
                                    </option>

                                    <option value="SERIAL">
                                        Serial
                                    </option>

                                    <option value="HTTP">
                                        HTTP
                                    </option>

                                    <option value="DICOM">
                                        DICOM
                                    </option>

                                    <option value="BLUETOOTH">
                                        Bluetooth
                                    </option>

                                    <option value="OTHER">
                                        Other
                                    </option>

                                </select>

                            </div>


                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    IP Address
                                </label>

                                <input
                                    type="text"
                                    name="ip_address"
                                    className="form-control"
                                    placeholder="192.168.1.100"
                                    value={
                                        formData.ip_address
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>


                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    Port
                                </label>

                                <input
                                    type="number"
                                    name="port"
                                    className="form-control"
                                    placeholder="2000"
                                    value={
                                        formData.port
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>

                        </div>


                        <div className="row">

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    MAC Address
                                </label>

                                <input
                                    type="text"
                                    name="mac_address"
                                    className="form-control"
                                    value={
                                        formData.mac_address
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>


                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    AE Title
                                </label>

                                <input
                                    type="text"
                                    name="ae_title"
                                    className="form-control"
                                    value={
                                        formData.ae_title
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>

                        </div>


                        <div className="row">

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Gateway
                                </label>

                                <select
                                    name="gateway"
                                    className="form-control"
                                    value={
                                        formData.gateway
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                >

                                    <option value="">
                                        Select Gateway
                                    </option>

                                    {gateways.map(
                                        gateway => (
                                            <option
                                                key={
                                                    gateway.id
                                                }
                                                value={
                                                    gateway.id
                                                }
                                            >
                                                {
                                                    gateway.gateway_name
                                                }
                                            </option>
                                        )
                                    )}

                                </select>

                            </div>

                        </div>

                    </div>

                </div>


                <div className="card shadow-sm mb-4">

                    <div className="card-header">

                        <strong>
                            Hospital Location
                        </strong>

                    </div>


                    <div className="card-body">

                        <div className="row">

                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    Ward
                                </label>

                                <input
                                    type="text"
                                    name="ward"
                                    className="form-control"
                                    placeholder="ICU"
                                    value={
                                        formData.ward
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>


                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    Room
                                </label>

                                <input
                                    type="text"
                                    name="room"
                                    className="form-control"
                                    placeholder="ICU-01"
                                    value={
                                        formData.room
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>


                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    Bed
                                </label>

                                <input
                                    type="text"
                                    name="bed"
                                    className="form-control"
                                    placeholder="Bed-01"
                                    value={
                                        formData.bed
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>

                        </div>

                    </div>

                </div>


                <div className="card shadow-sm mb-4">

                    <div className="card-header">

                        <strong>
                            Maintenance
                        </strong>

                    </div>


                    <div className="card-body">

                        <div className="row">

                            <div className="col-md-3 mb-3">

                                <label className="form-label">
                                    Installation Date
                                </label>

                                <input
                                    type="date"
                                    name="installation_date"
                                    className="form-control"
                                    value={
                                        formData.installation_date
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>


                            <div className="col-md-3 mb-3">

                                <label className="form-label">
                                    Warranty Expiry
                                </label>

                                <input
                                    type="date"
                                    name="warranty_expiry"
                                    className="form-control"
                                    value={
                                        formData.warranty_expiry
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>


                            <div className="col-md-3 mb-3">

                                <label className="form-label">
                                    Calibration Due
                                </label>

                                <input
                                    type="date"
                                    name="calibration_due"
                                    className="form-control"
                                    value={
                                        formData.calibration_due
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>


                            <div className="col-md-3 mb-3">

                                <label className="form-label">
                                    Service Due
                                </label>

                                <input
                                    type="date"
                                    name="service_due"
                                    className="form-control"
                                    value={
                                        formData.service_due
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>

                        </div>

                    </div>

                </div>


                <div className="text-center mb-5">

                    <button
                        type="button"
                        className="btn btn-secondary me-2"
                        onClick={() =>
                            navigate("/iot-devices/")
                        }
                    >
                        Cancel
                    </button>


                    <button
                        type="submit"
                        className="btn btn-success"
                        disabled={loading}
                    >
                        {loading
                            ? "Saving..."
                            : id
                                ? "Update Device"
                                : "Register Device"}
                    </button>

                </div>

            </form>

        </section>
    );
}
export default IoTDeviceForm;
